/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from 'react-redux'
import {
  useLazyGetAppTypesWithRolesQuery,
  //useLazyGetDomainNameQuery,
} from '../../api/app/UserManagementApiService'
import { useEffect } from 'react'
import { addApplicationTypes } from '../../redux/reducers/UserRolesReducer'
import { ApplicationTypesData } from '../../interface/response/UserRolesResponse'
import { RootState } from '../../store/Store'
interface AppTypes {
  [key: string]: string
}

export const useAddUserDetailsHooks = () => {
  const userRolesData = useSelector(
    (state: RootState) => state.userRole.userInfo,
  )
  const [getAppTypesWithRoleList, AppTypesWithRoles] =
    useLazyGetAppTypesWithRolesQuery()
  //const [getDomainName, domainNameData] = useLazyGetDomainNameQuery()
  const dispatch = useDispatch()

  // useEffect(() => {
  //   getDomainName('')
  // }, [])

  useEffect(() => {
    async function fetchAppTypesData() {
      try {
        const appTypesData = await getAppTypesWithRoleList(false)
        if (appTypesData?.data) {
          const applicationTypes: AppTypes = {}
          appTypesData?.data.map(
            (type: ApplicationTypesData) =>
              (applicationTypes[type.applicationType] = type.applicationCode),
          )
          dispatch(addApplicationTypes(applicationTypes))
        }
      } catch (error) {
        console.log(error)
      }
    }
    fetchAppTypesData()
  }, [])

  return {
    userRolesData,
    AppTypesWithRoles,
    //domainList: domainNameData?.data,
  }
}
